module.exports = __webpack_public_path__ + "static/media/IMG_6561.80425b25.JPG";